module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAbCAYAAACAyoQSAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD0SURBVHgBvdXtDYIwEAbgt7iAI9QR3KAjOAIjuIFs4Ai6gSMwCv71l2xwXmNPRCliv57koimkxxvgAAIQ0ZGr49IogRsZGlxQAjdqacwgJ25Q07cWObn7OMUgB09K0SGHmZSiQUo/Uoo71xqpLEiZNi1vdKDlbFqNGHaDP1KKuIHBG5wpjEEIlzJU2MCISBmWNjKl8A6MyrPeIJ698GbqgPpcoOcjn2qs9VwbpVT/vjiV9IR07ITaz55B4w90SnquaUd5tL6GS4Z6DFMypXilrSQl/2jkZZ+Xnf2jJGWBptaVa7tyKWuUYV+hW+W6l9IX7jd4ACzB+1Z3QBVXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/growing-triangle-white.png
// module id = nv3T
// module chunks = 1